export const ClimateRegion = [
  { label: 'Alaska', value: 584 },
  { label: 'Alabama', value: 2803 },
  { label: 'Arizona', value: 583 },
  { label: 'California', value: 1986 },
  { label: 'Colorado', value: 582 },
  { label: 'Connecticut', value: 935 },
  { label: 'District of Columbia', value: 1402 },
  { label: 'Delaware', value: 1401 },
  { label: 'Florida', value: 2804 },
  { label: 'Georgia', value: 2805 },
  { label: 'Hawaii', value: 2806 },
  { label: 'Iowa', value: 1400 },
  { label: 'Idaho', value: 581 },
  { label: 'Illinois', value: 936 },
  { label: 'Indiana', value: 937 },
  { label: 'Kansas', value: 1403 },
  { label: 'Kentucky', value: 1404 },
  { label: 'Louisiana', value: 2807 },
  { label: 'Massachusetts', value: 938 },
  { label: 'Maryland', value: 1405 },
  { label: 'Maine', value: 580 },
  { label: 'Michigan', value: 939 },
  { label: 'Minnesota', value: 934 },
  { label: 'Missouri', value: 1406 },
  { label: 'Mississippi', value: 585 },
  { label: 'Montana', value: 586 },
  { label: 'North Carolina', value: 1987 },
  { label: 'North Dakota', value: 587 },
  { label: 'Nebraska', value: 933 },
  { label: 'New Hampshire', value: 588 },
  { label: 'New Jersey', value: 1407 },
  { label: 'New Mexico', value: 932 },
  { label: 'Nevada', value: 931 },
  { label: 'New York', value: 589 },
  { label: 'Ohio', value: 930 },
  { label: 'Oklahoma', value: 2808 },
  { label: 'Oregon', value: 929 },
  { label: 'Pennsylvania', value: 928 },
  { label: 'Rhode Island', value: 590 },
  { label: 'South Carolina', value: 1988 },
  { label: 'South Dakota', value: 579 },
  { label: 'Tennessee', value: 1989 },
  { label: 'Texas', value: 2809 },
  { label: 'Utah', value: 940 },
  { label: 'Virginia', value: 1408 },
  { label: 'Vermont', value: 578 },
  { label: 'Washington', value: 941 },
  { label: 'Wisconsin', value: 577 },
  { label: 'West Virginia', value: 1409 },
  { label: 'Wyoming', value: 576 },
];

export const AvgElectricityRate = {
  Alaska: 21.32,
  Alabama: 12.38,
  Arkansas: 9.42,
  Arizona: 11.7,
  California: 21.43,
  Colorado: 12.14,
  Connecticut: 21.29,
  'District of Columbia': 12.26,
  Delaware: 11.77,
  Florida: 11.65,
  Georgia: 10.94,
  Hawaii: 30.55,
  Iowa: 10.87,
  Idaho: 10.05,
  Illinois: 12.3,
  Indiana: 12.25,
  Kansas: 11.87,
  Kentucky: 10.46,
  Louisiana: 9.58,
  Massachusetts: 22.32,
  Maryland: 12.61,
  Maine: 16.5,
  Michigan: 16.92,
  Minnesota: 12.48,
  Missouri: 9.38,
  Mississippi: 10.88,
  Montana: 10.72,
  'North Carolina': 10.6,
  'North Dakota': 9.44,
  Nebraska: 9.41,
  'New Hampshire': 18.93,
  'New Jersey': 16.18,
  'New Mexico': 12.53,
  Nevada: 11.53,
  'New York': 18.27,
  Ohio: 11.83,
  Oklahoma: 8.92,
  Oregon: 11.01,
  Pennsylvania: 13.09,
  'Rhode Island': 23.41,
  'South Carolina': 11.99,
  'South Dakota': 10.99,
  Tennessee: 10.36,
  Texas: 11.39,
  Utah: 10.04,
  Virginia: 11.05,
  Vermont: 18.38,
  Washington: 9.76,
  Wisconsin: 14.05,
  'West Virginia': 11.2,
  Wyoming: 10.47,
};

export const CapacityRange = [
  {
    label: '9,000 BTU',
    value: 9000,
  },
  {
    label: '12,000 BTU',
    value: 12000,
  },
  {
    label: '18,000 BTU',
    value: 18000,
  },
  {
    label: '24,000 BTU',
    value: 24000,
  },
  {
    label: '30,000 BTU',
    value: 30000,
  },
  {
    label: '36,000 BTU',
    value: 36000,
  },
  {
    label: '48,000 BTU',
    value: 48000,
  },
];

export const CurrentSeer = [
  {
    label: '9 SEER',
    value: 9,
  },
  {
    label: '10 SEER',
    value: 10,
  },
  {
    label: '11 SEER',
    value: 11,
  },
  {
    label: '12 SEER',
    value: 12,
  },
  {
    label: '13 SEER',
    value: 13,
  },
  {
    label: '14 SEER',
    value: 14,
  },
  {
    label: '15 SEER',
    value: 15,
  },
  {
    label: '16 SEER',
    value: 16,
  },
  {
    label: '17 SEER',
    value: 17,
  },
  {
    label: '18 SEER',
    value: 18,
  },
  {
    label: '19 SEER',
    value: 19,
  },
  {
    label: '20 SEER',
    value: 20,
  },
  {
    label: '21 SEER',
    value: 21,
  },
  {
    label: '22 SEER',
    value: 22,
  },
  {
    label: '23 SEER',
    value: 23,
  },
  {
    label: '24 SEER',
    value: 24,
  },
];

export const NewSeer = [
  {
    label: '10 SEER',
    value: 10,
  },
  {
    label: '11 SEER',
    value: 11,
  },
  {
    label: '12 SEER',
    value: 12,
  },
  {
    label: '13 SEER',
    value: 13,
  },
  {
    label: '14 SEER',
    value: 14,
  },
  {
    label: '15 SEER',
    value: 15,
  },
  {
    label: '16 SEER',
    value: 16,
  },
  {
    label: '17 SEER',
    value: 17,
  },
  {
    label: '18 SEER',
    value: 18,
  },
  {
    label: '19 SEER',
    value: 19,
  },
  {
    label: '20 SEER',
    value: 20,
  },
  {
    label: '21 SEER',
    value: 21,
  },
  {
    label: '22 SEER',
    value: 22,
  },
  {
    label: '23 SEER',
    value: 23,
  },
  {
    label: '24 SEER',
    value: 24,
  },
  {
    label: '25 SEER',
    value: 25,
  },
];

export const GatedForm = [
  {
    formTitle: 'To get unlimited calculations, sign up for our email list',
    termsText: null,
    marketoForm: {
      url: 'https://app-sj26.marketo.com/#FO2147A1ZN13LA1',
      name: 'WC TOFU Tools.FORM TOFU Tools',
      status: 'approved',
      knownVisitor: {
        type: 'form',
      },
    },
    onFormSubmissionModalMarketoForm: null,
    useEmbeddedForm: false,
    thankyou: null,
    thankyouSnackbar: null,
    redirectUrl: null,
  },
];
